import React from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';

const equipmentItems = [
  {
    name: "Bin Cleaning",
    image: "https://customer-assets.emergentagent.com/job_green-funding-bros/artifacts/e7cfx93p_Bin%20Cleaning.png",
    slug: "bin-cleaning"
  },
  {
    name: "Dumpster",
    image: "https://customer-assets.emergentagent.com/job_green-funding-bros/artifacts/x4ll8suv_Dumpster.png",
    slug: "dumpster"
  },
  {
    name: "Parking Lot Sweeper",
    image: "https://customer-assets.emergentagent.com/job_green-funding-bros/artifacts/xzr32vd0_Parking%20lot%20sweeper.png",
    slug: "parking-lot-sweeper"
  },
  {
    name: "Roll Off Dumpster Truck",
    image: "https://customer-assets.emergentagent.com/job_green-funding-bros/artifacts/0t5grbpx_Roll%20Off%20Dumpster%20Truck.png",
    slug: "roll-off-dumpster-truck"
  },
  {
    name: "Side Loader",
    image: "https://customer-assets.emergentagent.com/job_green-funding-bros/artifacts/6vfztave_side%20loader.png",
    slug: "side-loader"
  },
  {
    name: "Waste Pump Truck",
    image: "https://customer-assets.emergentagent.com/job_green-funding-bros/artifacts/2s492eyg_Wast%20Pump%20Truck.png",
    slug: "waste-pump-truck"
  }
];

const WeLoanOn = () => {
  // Individual item hover animation
  const handleMouseEnter = (e) => {
    gsap.to(e.currentTarget, {
      y: -10,
      scale: 1.05,
      duration: 0.3,
      ease: 'power2.out',
    });
  };

  const handleMouseLeave = (e) => {
    gsap.to(e.currentTarget, {
      y: 0,
      scale: 1,
      duration: 0.3,
      ease: 'power2.out',
    });
  };

  return (
    <section id="we-loan-on" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#0A1628] mb-2">
            WE LEND ON
          </h2>
          <div className="w-24 h-1 bg-[#00A86B] mx-auto mt-4"></div>
        </div>

        {/* Equipment Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {equipmentItems.map((item, index) => (
            <Link 
              key={index}
              to={`/equipment/${item.slug}`}
              className="equipment-item group flex flex-col items-center text-center"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {/* Icon Container - 20% larger */}
              <div className="w-48 h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 mb-4 flex items-center justify-center p-4 rounded-2xl bg-gray-50 group-hover:bg-[#00A86B]/10 transition-colors border-2 border-transparent group-hover:border-[#00A86B]">
                <img 
                  src={item.image} 
                  alt={item.name}
                  className="w-full h-full object-contain"
                />
              </div>
              {/* Label */}
              <h3 className="font-bold text-[#0A1628] text-lg md:text-xl group-hover:text-[#00A86B] transition-colors uppercase tracking-wide">
                {item.name}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WeLoanOn;
